
































import { Vue, Component, Prop } from 'vue-property-decorator'
import ApiService from '@/services/apiService'
import { UrlType } from '@/constants/urlType'
import ListSectionModel from '@/models/navigation/listSectionModel'
import SectionedList from '@/components/lists/SectionedList.vue'
import ExtensionCategoryQuestionAnswerModel from '@/models/extension/extensionCategoryQuestionAnswerModel'
import AddDialog from '@/components/dialogs/AddDialog.vue'
import ExtensionCategoryQuestionModel from '@/models/extension/extensionCategoryQuestionModel'
import Validation from '@/mixins/validation'
import jsfileDownload from 'js-file-download'
import fileDownload from 'js-file-download'
import apiService from '@/services/apiService'
import Investigation from './Investigation.vue'
import InvestigationModel from '../models/investigation/investigationModel'

@Component({
  components: {
    SectionedList,
    AddDialog
  }
})
export default class Findings extends Validation {
  @Prop(String) readonly id!: string

  private considerations: Array<
    ListSectionModel<ExtensionCategoryQuestionModel>
  > = []
  private dialog: boolean = false
  private answer: ExtensionCategoryQuestionAnswerModel = new ExtensionCategoryQuestionAnswerModel()

  private async created() {
    await this.getConsiderations()
  }

  private async getConsiderations() {
    const considerations: Array<ListSectionModel<
      ExtensionCategoryQuestionModel
    >> = await ApiService.getAllById(UrlType.Considerations, this.id)

    this.getIcons(considerations)

    this.considerations = considerations
  }

  private getIcons(
    considerations: Array<ListSectionModel<ExtensionCategoryQuestionModel>>
  ) {
    if (considerations.length) {
      for (const consideration of considerations) {
        switch (consideration.key) {
          case 'Barrier':
            consideration.icon = 'barrier.png'
            break
          case 'Change':
            consideration.icon = 'change.png'
            break
          case 'Human Factor':
            consideration.icon = 'human-factor.png'
            break
          case 'Event':
            consideration.icon = 'event.png'
            break
          case 'Data':
            consideration.icon = 'data.png'
            break
        }
      }
    }
  }

  private async editAnswerNotes(
    question: ExtensionCategoryQuestionModel
  ): Promise<void> {
    this.answer = await ApiService.get(
      UrlType.ExtensionCategoryQuestionAnswer,
      question.answerId
    )

    this.dialog = true
  }

  private async saveAnswerNotes(valid: boolean): Promise<void> {
    if (valid) {
      await ApiService.put(
        UrlType.ExtensionCategoryQuestionAnswer,
        this.answer.extensionCategoryQuestionAnswerId,
        this.answer
      )

      this.dialog = false
    }
  }

  private async getPrint(): Promise<void> {
    try {
      const file = await apiService.getFile(this.id)
      const investigation = await apiService.get<InvestigationModel>(
        UrlType.Investigation,
        this.id
      )

      fileDownload(
        new Blob([file.data], {
          type: file.extension ? file.extension : undefined
        }),
        `findings.pdf`
      )
    } catch (error) {
      alert(error)
    }
  }
}
